"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _checkForDangerouslySet = require("../../utils/methods/checkForDangerouslySet");
require("./Alert.scss");
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _useCheckForInternetExplorer = _interopRequireDefault(require("../../utils/hooks/useCheckForInternetExplorer"));
var _AlertMethods = require("./AlertMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Alert = _ref => {
  let {
    type,
    text,
    name,
    handleClose
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const {
    IE
  } = (0, _useCheckForInternetExplorer.default)();
  const renderAlertText = text => {
    if (text && typeof text === "object") {
      return text;
    } else {
      return (0, _checkForDangerouslySet.checkAndSet)(text, "ter-alert");
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-label": "Alert",
    tabIndex: mouse ? "" : "0",
    className: `
        ter-alert
        ${mouse ? `ter-alert--${type || "default"}` : `tabFocus ter-alert--${type || "default"}`}
      `
  }, renderAlertText(text), /*#__PURE__*/_react.default.createElement("button", {
    className: IE === true ? "ter-alert__close ter-alert__ie-close" : "ter-alert__close",
    onClick: e => handleClose(e),
    onKeyDown: e => (0, _AlertMethods.activateClickWithEnter)(e, name, mouse, handleClose),
    "aria-label": "Close Alert"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: IE === true ? "ter-alert__ie-text" : "ter-alert__no-visible-text"
  }, "x"), /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: mouse ? "" : "0",
    className: (0, _AlertMethods.renderCorrectClass)(IE, mouse)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "ter-icon--open-x-dark-16px",
    size: "14px"
  }))));
};
var _default = Alert;
exports.default = _default;
Alert.propTypes = {
  handleClose: _propTypes.default.func.isRequired,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  type: _propTypes.default.string,
  name: _propTypes.default.string,
  IE: _propTypes.default.bool
};